import React, { useEffect } from 'react';

import { useParentGet } from 'actions/parent-pii';

import { FlexView, Row } from '@cuemath/comps';
import BallLoader from 'comps/ball-loader';
import { trackEvent } from 'modules/analytics';
import { useParams } from 'react-router-dom';
import { Grid, Message } from 'semantic-ui-react';
import { getCookie } from 'utils';

import styled from 'styled-components';
import ParentProfile from './parentProfile';
import { InfoViewLabel } from '../utils/comps';

const FetchErrorContainer = styled(FlexView)`
  margin: 200px;
`;

const Parent = () => {
  const { parentId } = useParams();

  const { get: getParent, data, isProcessing, isProcessingFailed } = useParentGet();

  useEffect(() => {
    trackEvent('PARENT_PERSONAL_INFORMATION_VIEWED', {
      parentServiceId: parentId,
      user_id: getCookie('emp_id'),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getParent(parentId);
  }, [parentId, getParent]);

  return (
    <FlexView alignItems="center">
      <InfoViewLabel resource="Parent" />
      <Grid>
        {isProcessing && <BallLoader />}
        {isProcessingFailed && (
          <FetchErrorContainer>
            <p>Not able to fetch data</p>
          </FetchErrorContainer>
        )}
        {data && (
          <Grid.Row>
            <Grid.Column>
              <ParentProfile parentProfileInfo={data} />
            </Grid.Column>
          </Grid.Row>
        )}
      </Grid>
    </FlexView>
  );
};

export default Parent;
